import React from 'react';

// ##### FLOWS CLASSIFY (body only — title lives in parent accordion)
const CustomFlowsClassify = ({ reload }) => {
  return (
    <div className="flex items-center justify-center min-h-[5rem] rounded-lg border border-dashed border-gray-200 bg-gray-50/80">
      <span className="text-sm text-gray-500">Coming Soon</span>
    </div>
  );
};

export default CustomFlowsClassify;
